module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [(_vm.idioma === 'DE') ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Ein/Aus")]) : (_vm.idioma === 'EN') ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("On/Off")]) : (_vm.idioma === 'ES') ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Encendido / Apagado")]) : _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Ligado/Desligado")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [(_vm.idioma === 'DE') ? _c('th', [_vm._v("Variable")]) : (_vm.idioma === 'EN') ? _c('th', [_vm._v("Variable")]) : (_vm.idioma === 'ES') ? _c('th', [_vm._v("Variable")]) : _c('th', [_vm._v("Variável")]), _vm._v(" "), (_vm.idioma === 'DE') ? _c('th', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("Werte")]) : (_vm.idioma === 'EN') ? _c('th', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("Values")]) : (_vm.idioma === 'ES') ? _c('th', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("Valor")]) : _c('th', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("Valor")])])]), _vm._v(" "), (_vm.idioma === 'DE') ? _c('tbody', _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelDe')), function(registro) {
    return _c('tr', {
      key: registro.id
    }, [_c('td', [_vm._v(_vm._s(registro.labelDe))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])])])
  }), 0) : (_vm.idioma === 'EN') ? _c('tbody', _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelEn')), function(registro) {
    return _c('tr', {
      key: registro.id
    }, [_c('td', [_vm._v(_vm._s(registro.labelEn))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])])])
  }), 0) : (_vm.idioma === 'ES') ? _c('tbody', _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelEs')), function(registro) {
    return _c('tr', {
      key: registro.id
    }, [_c('td', [_vm._v(_vm._s(registro.labelEs))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])])])
  }), 0) : _c('tbody', _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelPtBr')), function(registro) {
    return _c('tr', {
      key: registro.id
    }, [_c('td', [_vm._v(_vm._s(registro.labelPtBr))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [(_vm.idioma === 'DE') ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Werte")]) : (_vm.idioma === 'EN') ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Values")]) : (_vm.idioma === 'ES') ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Valores")]) : _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Valores")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [(_vm.idioma === 'DE') ? _c('th', [_vm._v("Variable")]) : (_vm.idioma === 'EN') ? _c('th', [_vm._v("Variable")]) : (_vm.idioma === 'ES') ? _c('th', [_vm._v("Variable")]) : _c('th', [_vm._v("Variável")]), _vm._v(" "), (_vm.idioma === 'DE') ? _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Werte")]) : (_vm.idioma === 'EN') ? _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Values")]) : (_vm.idioma === 'ES') ? _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Valor")]) : _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Valor")])])]), _vm._v(" "), (_vm.idioma === 'DE') ? _c('tbody', _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, false, 'is_bool'), 'labelDe')), function(registro) {
    return _c('tr', {
      key: registro.id
    }, [_c('td', [_vm._v(_vm._s(registro.labelDe))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                      " + _vm._s(parseFloat(registro.valor).toFixed(1)) + " " + _vm._s(registro.unidade_medida) + "\n                     ")])])])])
  }), 0) : (_vm.idioma === 'EN') ? _c('tbody', _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, false, 'is_bool'), 'labelEn')), function(registro) {
    return _c('tr', {
      key: registro.id
    }, [_c('td', [_vm._v(_vm._s(registro.labelEn))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                      " + _vm._s(parseFloat(registro.valor).toFixed(1)) + " " + _vm._s(registro.unidade_medida) + "\n                     ")])])])])
  }), 0) : (_vm.idioma === 'ES') ? _c('tbody', _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, false, 'is_bool'), 'labelEs')), function(registro) {
    return _c('tr', {
      key: registro.id
    }, [_c('td', [_vm._v(_vm._s(registro.labelEs))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                      " + _vm._s(parseFloat(registro.valor).toFixed(1)) + " " + _vm._s(registro.unidade_medida) + "\n                     ")])])])])
  }), 0) : _c('tbody', _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, false, 'is_bool'), 'labelPtBr')), function(registro) {
    return _c('tr', {
      key: registro.id
    }, [_c('td', [_vm._v(_vm._s(registro.labelPtBr))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                      " + _vm._s(parseFloat(registro.valor).toFixed(1)) + " " + _vm._s(registro.unidade_medida) + "\n                     ")])])])])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-sm-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0010721d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Manutencao.vue
// module id = 629
// module chunks = 1